const config = {
    apiHost: process.apiHost,
}

export default config



// WEBPACK FOOTER //
// ./src/api/config.js